import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, RecordedTime } from '../../../Components/Form';
import { useCustomer } from '../../../Data/Customers';

const RecordedTimeModal = ({job, occurrence, onClose, then}) => {
    return <Modal title="Recorded time" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner {...{job, occurrence, then}} />}
    </Modal>
}

const Inner = ({job, occurrence, then}) => {
    const {recordJobOccurrenceTime} = useCustomer(job.customerId);

    return <Form
        data={{ recordedTime: occurrence?.recordedTime ?? { periods: [] } }}
        onSubmit={(data) => recordJobOccurrenceTime(job.id, occurrence.id, data).then(() => then && then())}
        closeModalOnSubmit
    >
        <RecordedTime />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default RecordedTimeModal;
